import { useState } from 'react';

import useModal from '@hooks/useModal';
import useInView from '@hooks/useInView';
import ServiceBookingBottomsheet from '@containers/clinics/profile/components/service-booking/ServiceBookingBottomsheet';
import { useGetUserServiceByDoctorId } from '@api/profile/index.rq';
import {
  BookingHeaderProfile,
  ProfileEnum,
  UserServiceItem,
} from '@models/clinic-list';
import { DoctorProfile } from '@models/ocs/doctor';
import { GetUserServiceByDoctorIdItemModel } from '@models/profile';
import { DoctorClinicItemModel } from '@models/in-person-booking';

type UseServiceBookingParams = {
  doctorId: number;
  doctorProfile?: DoctorProfile;
  profileId: number;
};

const useServiceBooking = ({
  doctorId,
  doctorProfile,
  profileId,
}: UseServiceBookingParams) => {
  const { addModal } = useModal();

  const { ref: servicesCarouselRef, isInView: servicesCarouselIsInView } =
    useInView();

  const [selectedService, setSelectedService] = useState<
    GetUserServiceByDoctorIdItemModel | UserServiceItem | null
  >(null);

  const { data: userServiceData, isLoading: userServiceDataIsLoading } =
    useGetUserServiceByDoctorId(
      {
        id: doctorId,
        pageNumber: 1,
        pageSize: 50,
      },
      {
        enabled: !!doctorId,
      },
    );

  const handleOpenServiceCalendar = async ({
    service,
    clinic,
  }: {
    service?: UserServiceItem | GetUserServiceByDoctorIdItemModel;
    clinic?: DoctorClinicItemModel;
  }) => {
    if (!profileId) {
      return;
    }

    const profile: BookingHeaderProfile = {
      ownerId: doctorId,
      profileType: ProfileEnum.DOCTOR,
      basicInfo: {
        fullName: doctorProfile?.fullName,
        description: doctorProfile?.aboutDoctor,
        coverImageUrl: doctorProfile?.imageUrl,
      },
      addresses: [
        {
          address: clinic?.clinicAddress ?? '',
        },
      ],
    };

    setSelectedService(service);

    addModal({
      modal: ServiceBookingBottomsheet,
      props: {
        profile,
        service,
        profileId,
        clinic: clinic,
      },
    });
  };

  return {
    servicesCarouselRef,
    servicesCarouselIsInView,
    userServiceData,
    selectedService,
    handleOpenServiceCalendar,
    userServiceDataIsLoading,
  };
};

export default useServiceBooking;
